import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import TagManager from "@sooro-io/react-gtm-module";

import configureStore, { history } from "./store";
import "./firebase/firebase";
import App from "./containers/App";
import { onSigninCallback, userManager } from "lib/auth.config";
import { DEV_ENV } from "constants/app";

if (!DEV_ENV) {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
  });
}

export const store = configureStore();

const MainApp = () => (
  <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  </AuthProvider>
);

export default MainApp;
